import { Route, Routes, Navigate } from 'react-router-dom';

import './products.css';
import Items from './Items';

function Products() {
    return (
        <>
            <Routes>
                <Route path='*' index element={<Navigate to='products' />} />
                <Route path='products' element={<Items />} />
				<Route path='products/:id' element={<Items />} />
            </Routes>
        </>
    )
}

export default Products